import React from 'react'
import Select from 'react-select'
import options from './countries.json'
import colors from 'styles/colors'
import { ErrorMessage } from 'formik'
import FormErrorMessage from '../FormErrorMessage'

const customStyles = {
  placeholder: provided => ({
    ...provided,
    color: colors.placeholderColor,
    fontWeight: 300,
  }),
  option: (provided, state) => ({
    ...provided,
    color: 'currentColor',
    backgroundColor: state.isSelected ? 'rgba(11,224,148,.5)' : 'transparent',
    padding: '16px',
    cursor: 'pointer',
  }),
  container: () => ({
    position: 'relative',
    width: '100%',
    outline: 'none',
  }),
  control: (provided, state) => ({
    ...provided,
    borderRadius: '7px',
    height: '46px',
    lineHeight: '24px',
    paddingLeft: 0,
    borderColor: state.isFocused ? `${colors.greenMain} !important` : '#e8ecf3',
    boxShadow: state.isFocused ? `0 0 0 1px ${colors.greenMain}` : 'none',
  }),
  valueContainer: provided => ({
    ...provided,
    paddingLeft: 16,
  }),
  indicatorSeparator: provided => ({
    ...provided,
    display: 'none',
  }),
  dropdownIndicator: provided => ({
    ...provided,
    color: colors.greenMain,
  }),
}

const CountrySelect = ({ field, form, placeholder }) => (
  <>
    <Select
      options={options}
      name={field.name}
      placeholder={placeholder}
      value={
        options ? options.find(option => option.value === field.value) : ''
      }
      onChange={option => form.setFieldValue(field.name, option.value)}
      onBlur={field.onBlur}
      styles={customStyles}
    />
    <ErrorMessage component={FormErrorMessage} name={field.name} />
  </>
)

export default CountrySelect
